<script>

	export let field;
	export let response = '';

	let inputmode = "text";
	let autocomplete;

	if (field.hook == "f") {
		autocomplete = "given-name";
	} else if (field.hook == "l") {
		autocomplete = "family-name";
	} else if (field.hook == "e") {
		autocomplete = "email";
		inputmode = "email"
	} else if (field.component == "PhoneField") {
		inputmode = "tel";
		autocomplete = "tel";
	} else if (field.component == "NumberField") {
		inputmode = "decimal";
	} else if (field.component == "UrlField") {
		inputmode = "url";
	}

</script>

<input
	type="text"
	id="azn_s_i_{field.ref}"
	name={field.ref}
	class="textual"
	bind:value={response}
	{inputmode}
	{autocomplete}
	on:focus
/>
